(() => {
  let busy = false;
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-yunic-rec-add]');
    if (!button || busy) return;
    event.preventDefault();
    busy = true;
    const section = button.closest('.yunic-cart-rec');
    const status = section.querySelector('.yunic-cart-rec__status');
    const label = button.textContent;
    let added = false;
    button.disabled = true;
    button.textContent = section.dataset.adding;
    status.textContent = '';
    try {
      const response = await fetch(section.dataset.addUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.yunicRecAdd), quantity: 1 }] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || section.dataset.error);
      added = true;
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      const refreshed = await fetch(`${section.dataset.cartUrl}?view=json`, { cache: 'no-store' });
      if (!refreshed.ok) throw new Error(section.dataset.error);
      const html = await refreshed.text();
      const fragment = new DOMParser().parseFromString(html, 'text/html');
      const count = fragment.querySelector('[data-cart-item-count]')?.dataset.cartItemCount;
      const panel = document.querySelector('#cart-info');
      if (!panel || count === undefined) throw new Error(section.dataset.error);
      panel.innerHTML = html;
      document.querySelectorAll('#CartCount, .cart-products-count').forEach(el => { el.textContent = count; });
    } catch (error) {
      if (added) { window.location.reload(); return; }
      status.textContent = error.message || section.dataset.error;
      button.disabled = false;
      button.textContent = label;
    } finally { busy = false; }
  });
})();
